module.exports = __webpack_public_path__ + "static/media/select-arrow-2.643341dd.svg";